module.exports = __webpack_public_path__ + "static/people-in-an-office-space.9a3a1d8c.webp";